<template>
    <div>
        <!--    <el-dialog title="打卡次数和提醒文案配置" :visible.sync="showCheckInPage">-->
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
            <el-button size="small" type="danger" @click="saveCheckInConfig()" >保 存</el-button>
        </div>
        <el-form :model="checkInConfig" label-width="120px">
            <el-form-item label="提醒文案" prop="remindText">
                <el-input v-model="checkInConfig.remindText" placeholder="提醒文案"></el-input>
            </el-form-item>
            <el-form-item label="最大打卡次数" prop="maxCount">
                <el-input-number v-model="checkInConfig.maxCount" placeholder="最大打卡次数"></el-input-number>
            </el-form-item>

        </el-form>
        <!--    </el-dialog>-->
    </div>

</template>

<script>
    import {getActiveCheckInConfig, saveActiveCheckInConfig} from "../../api/api";

    export default {
        name: "checkInConfig",
        data(){
            return{
                checkInConfig:{
                    activeNo: this.$route.query.activeNo,
                    remindText: '',
                    maxCount: 0
                },
            }
        },
        mounted(){
            this.handleCheckIn(this.checkInConfig.activeNo);
        },
        methods:{
            handleCheckIn(activeNo){
                this.checkInConfig.activeNo = activeNo;
                this.showCheckInPage = true;
                getActiveCheckInConfig({"activeNo": activeNo}).then((res) => {
                    if (res.data.status == 200 && res.data.value.length > 0) {
                        this.checkInConfig.remindText = res.data.value[0].remindText;
                        this.checkInConfig.maxCount = res.data.value[0].maxCount;
                    } else if(res.data.status != 200){
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveCheckInConfig(){
                saveActiveCheckInConfig(this.checkInConfig).then((res) => {
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });

                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/active/checkInConfig.vue